export default {
  namespaced: true,
  state: {
    memorizedEmail: null,
    rid: null,
    checkinFormType: ""
  },
  mutations: {

    saveReservationNumber(state, payload) {
      state.rid = payload
    },

    saveCheckinFormType(state, payload) {
      state.checkinFormType = payload
    },

    saveEmail(state, payload) {
      state.memorizedEmail = payload
    },

  },
  actions: {

    saveReservationNumber({ commit }, payload) {
      commit('saveReservationNumber', payload)
    },

    saveCheckinFormType({ commit }, payload) {
      commit('saveCheckinFormType', payload)
    },


    saveEmail({ commit }, payload) {
      commit('saveEmail', payload)
    },
  },
  getters: {
    checkinFormType: state => state.checkinFormType,
  }
};
